/**
 * shipmentLinkPermissions - Regras puras da Logística compartilhadas entre telas.
 *
 * - canViewShipmentLink: um vínculo da remessa só é listado/aberto quando o
 *   usuário pode ver o módulo que ele representa (mesmas chaves do modal de Veículo).
 * - recipientKindLabel: rótulo do tipo de destinatário a partir dos papéis.
 *
 * CHANGELOG:
 *   RELEASE: 2026-10-16 v1.0.0 - Criação inicial.
 */

export interface ShipmentLinkPermissionInput {
  isAdmin: boolean;
  canView: (key: string) => boolean;
  /** Módulo de O.S. ativo no tenant */
  serviceOrdersEnabled: boolean;
  /** Módulo de Tarefas ativo no tenant */
  tasksEnabled: boolean;
}

/** Chave de permissão de visualização por tipo de vínculo. */
export const SHIPMENT_LINK_PERMISSION: Record<string, string> = {
  service_order: 'os_list',
  deal: 'crm_deals',
  task: 'tasks_list',
  customer: 'crm_customers',
  vehicle: 'vehicles_list',
};

export function canViewShipmentLink(type: string, p: ShipmentLinkPermissionInput): boolean {
  const key = SHIPMENT_LINK_PERMISSION[type];
  if (!key) return false; // tipo fora da allowlist nunca é exibido
  if (type === 'service_order' && !p.serviceOrdersEnabled) return false;
  if (type === 'task' && !p.tasksEnabled) return false;
  return p.isAdmin || p.canView(key);
}

/** Rótulo do tipo de destinatário a partir dos papéis da pessoa. */
export function recipientKindLabel(customerId: string | null | undefined, roles: string[] = []): string {
  if (customerId) return 'Cliente';
  if (roles.includes('service_provider')) return 'Prestador';
  if (roles.includes('manufacturer')) return 'Fabricante';
  if (roles.includes('supplier')) return 'Fornecedor';
  return 'Pessoa';
}
